import React from 'react'

import css from './styles.module.scss'

const PrideMonthBanner = () => {
  return <div className={css.PrideMonthBanner} />
}

export default PrideMonthBanner
